// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"ed3430c4","453":"a492ffeb","489":"e74e8a59"}[chunkId] + ".chunk.js";
};